<template>
    <div>
        <img class="image" :src="product.Image.Src" :alt="product.Image.AltAttribute" />
        <div class="d-flex justify-content-center">
            <div class="form-group colour-selector">
                <select v-model="product.SelectedColorName" class="custom-select col" @change="updateImage(product)">
                    <option v-for="color in getColorOptions(product)" :key="color.Id" :value="color.Name">{{
                        product.value || color.Name
                    }}
                    </option>
                </select>
            </div>
        </div>
        <ProductPrice :product="product" />
    </div>
</template>

<script>
import { mergeDeepRight, pathOr } from "ramda";
import { findColorAttribute } from "../services/ProductHelpers";
import ProductPrice from "./ProductPrice";

const imageTag = mergeDeepRight({
    Image: { Src: null, AltAttribute: null }
});

export default {
    name: "ProductImageWithColourSelector",
    components: {
        ProductPrice
    },
    props: {
        initialProduct: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            product: imageTag(this.initialProduct)
        };
    },
    created() {
        this.initialiseImage(this.product);
    },
    methods: {
        getImageDataString(imageData) {
            return `data:${imageData.MimeType};charset=utf-8;base64,${imageData.PictureBinary}`;
        },
        updateImage(product) {
            const targetImage = product.ProductImages.find(
                image => image.TitleAttribute === product.SelectedColorName
            );
            if (targetImage) {
                product.Image = targetImage;
                product.Image.Src = this.getImageDataString(targetImage);
            }
            this.$emit("color-selected", {
                product: product,
                colorName: product.SelectedColorName
            });
        },
        initialiseImage(product) {
            const availableProductImage = this.product.ProductImages
                .find(image => pathOr(0, ['AttributeStockLevels', 'Color', image.TitleAttribute, 'Quantity'], this.product))
                || this.product.ProductImages[0]
                || {};
            product.SelectedColorName = availableProductImage.TitleAttribute;
            this.updateImage(product);
        },
        getColorOptions(product) {
            const attribute = findColorAttribute(product.Attributes);
            return attribute.ValueOptions.map(option => {
                const stockMap = (product.AttributeStockLevels || {})['Color'];
                const value = (stockMap || {})[option.Name];
                const isValidQuantity = stockMap && (!!value || value == 0);
                return { ...option, value, isValidQuantity }
            }).sort(option => option.isValidQuantity ? -1 : 1);
        }
    }
};
</script>

<style scoped lang="scss">
.colour-selector {
    width: 80%;
    margin-top: 16px;
}

img{
    width: 100%;
}
</style>
